import { IPermissionEdit } from "./IPermissionEdit"


export class PermissionAdmin {

    public selectAllPermissionAdmin!:IPermissionEdit

    public General!: {
        selectAll: boolean;

        viewEditSystemConfiguration: IPermissionEdit
        editClientURLCode: IPermissionEdit
        viewEditLocalization: IPermissionEdit;
        dataImportExport: IPermissionEdit
        viewEditLicensing: IPermissionEdit

    }

    public Location!: {
        selectAll: boolean;

        viewLocations: IPermissionEdit;
        addLocations: IPermissionEdit;
        editLocations: IPermissionEdit;
        activateDeactivateLocations: IPermissionEdit;

    }


    public ViewAddEditDeleteProductCategory!: {
        selectAll: boolean;
        viewAddEditDeleteProductCategory: IPermissionEdit;
    }

    public ProductAndService!: {
        selectAll: boolean;
        viewProductsServices: IPermissionEdit;
        addProductsServices: IPermissionEdit;
        editProductsAndServices: IPermissionEdit;
        editBasicProductAndServices: IPermissionEdit;
        activateDeactivateProductsServices: IPermissionEdit;
        deleteProductsServices: IPermissionEdit;
    }

    public Groups!: {
        selectAll: boolean;
        viewPermissionGroups: IPermissionEdit;
        addPermissionGroups: IPermissionEdit;
        editPermissionGroups: IPermissionEdit;
        deletePermissionGroups: IPermissionEdit;

    }


    public Users!: {
        selectAll: boolean;
        viewUsers: IPermissionEdit;
        addUsers: IPermissionEdit;
        editUsers: IPermissionEdit;
        deleteUsers: IPermissionEdit;
    }

    public Members!: {
        selectAll: boolean;
        viewMembers: IPermissionEdit;
        importMembers: IPermissionEdit;
    }


    public Clients!: {
        selectAll: boolean;
        viewClients: IPermissionEdit;
        addClients: IPermissionEdit;
        changeClients: IPermissionEdit;

    }


    public ViewGlobalAlerts!: {
        selectAll: boolean;
        viewGlobalAlerts: IPermissionEdit;
        addGlobalAlerts: IPermissionEdit;
        editGlobalAlerts: IPermissionEdit;
        deleteGlobalAlerts: IPermissionEdit;
        viewAddEditDeleteMyAlerts: IPermissionEdit;

    }

    public Kiosk!: {
        selectAll: boolean;
        viewKioskConfiguration: IPermissionEdit;
        addKioskConfiguration: IPermissionEdit;
        editKioskConfiguration: IPermissionEdit;
        deleteKioskConfiguration: IPermissionEdit;

    }

    constructor() {
        
    }

}